"use strict";
var __webpack_require__ = {};
(()=>{
    __webpack_require__.d = (exports1, definition)=>{
        for(var key in definition)if (__webpack_require__.o(definition, key) && !__webpack_require__.o(exports1, key)) Object.defineProperty(exports1, key, {
            enumerable: true,
            get: definition[key]
        });
    };
})();
(()=>{
    __webpack_require__.o = (obj, prop)=>Object.prototype.hasOwnProperty.call(obj, prop);
})();
(()=>{
    __webpack_require__.r = (exports1)=>{
        if ('undefined' != typeof Symbol && Symbol.toStringTag) Object.defineProperty(exports1, Symbol.toStringTag, {
            value: 'Module'
        });
        Object.defineProperty(exports1, '__esModule', {
            value: true
        });
    };
})();
var __webpack_exports__ = {};
__webpack_require__.r(__webpack_exports__);
__webpack_require__.d(__webpack_exports__, {
    pickDomainIDConfig: ()=>pickDomainIDConfig,
    generateEmptyDomainIDConfig: ()=>generateEmptyDomainIDConfig,
    pickMultiDomainIDConfig: ()=>pickMultiDomainIDConfig,
    mergeDomainIDConfig: ()=>mergeDomainIDConfig
});
const index_js_namespaceObject = require("../domain-id/index.js");
const pick = (obj, keys)=>Object.keys(obj).reduce((prev, curr)=>{
        if (!Array.isArray(keys) || keys.includes(curr)) prev[curr] = obj[curr];
        return prev;
    }, {});
const pickDomainIDConfig = (param)=>{
    let { configs, item, domainIDs } = param;
    const matchedDomainID = pick(configs, domainIDs);
    return Object.entries(matchedDomainID).reduce((prev, curr)=>{
        const [key, value] = curr;
        prev[key] = value[item];
        return prev;
    }, {});
};
const pickMultiDomainIDConfig = (param)=>{
    let { configs, domainIDs, items } = param;
    const matchedDomainID = pick(configs, domainIDs);
    return Object.entries(matchedDomainID).reduce((prev, curr)=>{
        const [key, value] = curr;
        prev[key] = pick(value, items);
        return prev;
    }, {});
};
const mergeDomainIDConfig = (originalConfig, mergingConfig)=>Object.entries(originalConfig).reduce((result, pickedArr)=>{
        const [originalDomainID, domainIDConfig] = pickedArr;
        const value = Object.assign({}, domainIDConfig);
        Object.keys(mergingConfig).forEach((item)=>{
            var _mergingConfig_mergingItem;
            const mergingItem = item;
            const result = null == (_mergingConfig_mergingItem = mergingConfig[mergingItem]) ? void 0 : _mergingConfig_mergingItem[originalDomainID];
            if ('string' != typeof result) throw new Error(`[CommonLib](mergeDomainIDConfig) cannot read property ${String(mergingItem)}.${pickDomainIDConfig} of mergingConfig`);
            value[mergingItem] = result;
        });
        result[originalDomainID] = value;
        return result;
    }, {});
const generateEmptyDomainIDConfig = (domainIDs)=>{
    const defaultDomainIDs = index_js_namespaceObject.allDomainIDs;
    return (domainIDs || defaultDomainIDs).reduce((prev, key)=>{
        prev[key] = {};
        return prev;
    }, {});
};
exports.generateEmptyDomainIDConfig = __webpack_exports__.generateEmptyDomainIDConfig;
exports.mergeDomainIDConfig = __webpack_exports__.mergeDomainIDConfig;
exports.pickDomainIDConfig = __webpack_exports__.pickDomainIDConfig;
exports.pickMultiDomainIDConfig = __webpack_exports__.pickMultiDomainIDConfig;
for(var __webpack_i__ in __webpack_exports__)if (-1 === [
    "generateEmptyDomainIDConfig",
    "mergeDomainIDConfig",
    "pickDomainIDConfig",
    "pickMultiDomainIDConfig"
].indexOf(__webpack_i__)) exports[__webpack_i__] = __webpack_exports__[__webpack_i__];
Object.defineProperty(exports, '__esModule', {
    value: true
});
